module.exports = __webpack_public_path__ + "img/rotateLogo_CH.6ad0abad.png";